import SectionTitle from "./SectionTitle";
import RegisterLink from "../../../components/RegisterLink";

const slotGames = [
  { name: "Booongo", img: "https://xt30sf.b-cdn.net/media/78d569172aa967c27768e.png" },
  { name: "JILI", img: "https://xt30sf.b-cdn.net/media/a6d78fa490d96fecc8694.png" },
  { name: "VPower", img: "https://xt30sf.b-cdn.net/media/83e6364b9be868ac00b4a.png" },
  { name: "Live22", img: "https://xt30sf.b-cdn.net/media/c95ae46b9be860b8f57f5.png" },
  { name: "Pragmatic Play", img: "https://xt30sf.b-cdn.net/media/fd436dac9be86b0241df5.png" },
  { name: "CQ9 Gaming", img: "https://xt30sf.b-cdn.net/media/9bca8f8b9be86ce05d969.png" },
  { name: "ACE333", img: "https://xt30sf.b-cdn.net/media/34e5c28c9be8645bc1055.png" },
  { name: "WF Gaming", img: "https://xt30sf.b-cdn.net/media/82a68164f9796a3c35a36.png" },
  { name: "918Kiss", img: "https://xt30sf.b-cdn.net/media/967ecbbc9be8690804f63.png" },
  { name: "Mega888", img: "https://xt30sf.b-cdn.net/media/8618043c9be860a2f02b8.png" },
  { name: "Joker", img: "https://xt30sf.b-cdn.net/media/6ba4b8cb9be868f41aa77.png" },
  { name: "Pegasus", img: "https://xt30sf.b-cdn.net/media/3b72138b9be8653c80ca4.png" },
];

const fishingGames = [
  { title: "Ocean King", body: "One of the most popular fishing games in Asia. Shoot fish to earn multipliers and jackpots. Adjustable betting options for all player levels." },
  { title: "Fishing God", body: "Casual entertainment with exciting multipliers. Compete with other players in real-time fishing action with adjustable betting options." },
];

const tableGames = [
  { title: "Dragon Tiger", body: "A fast-paced card game where you bet on Dragon or Tiger. Simple rules, instant results, and high excitement — perfect for Australian players who love quick action." },
  { title: "Poker & Card Games", body: "Enjoy a wide variety of multiplayer card games including Poker, Baccarat, and more, with competitive odds and smooth gameplay." },
];

const liveGames = [
  { title: "Live Baccarat (Evolution & Asia Gaming)", body: "Experience the thrill of real-time baccarat with professional dealers streamed in HD. Multiple tables available with varying bet limits. The dealer is very professional and live video is clear and smooth." },
  { title: "Live Roulette & Blackjack", body: "Powered by Evolution Gaming and Asia Gaming, enjoy authentic live dealer roulette and blackjack with real-time interaction and immersive gameplay." },
  { title: "Dragon Tiger Live", body: "Fast-paced live dealer Dragon Tiger with real-time results. Powered by top-tier live casino providers for the most authentic experience." },
  { title: "Live Casino Welcome Bonus 50%", body: "New live casino players enjoy a 50% Live Welcome Bonus on their first live casino deposit. More value, more excitement at every live table." },
];

export default function Games() {
  return (
    <section id="games" className="py-12">
      <SectionTitle>Games</SectionTitle>

      <p className="text-slate-300 leading-relaxed mb-8 text-sm">
        Ace96au offers more than 4000 games across multiple categories — from high RTP pokies and fishing games to live dealer tables and card games. Powered by top providers including JILI, VPower, BNG, Spadegaming, Pragmatic Play, Evolution Gaming, CQ9 Gaming, WF Gaming, Live22, Joker, Pegasus, ACE333, 918Kaya, 918Kiss and Mega888, every session delivers world-class entertainment. The game collection is constantly updated to provide players with a more exciting gaming experience.
      </p>

      {/* Slot Games */}
      <h3
        className="text-base font-bold mb-4 tracking-widest uppercase"
        style={{ color: "#105CE8", fontFamily: "'Cinzel', serif" }}
      >
        Slot Games
      </h3>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-10">
        {slotGames.map((game) => (
          <RegisterLink
            key={game.name}
            trackLabel={`games-slot-${game.name}`}
            className="group relative rounded-xl overflow-hidden cursor-pointer block"
            style={{ border: "1px solid rgba(16,92,232,0.15)" }}
          >
            <div className="w-full" style={{ aspectRatio: "320/407" }}>
              <img
                src={game.img}
                alt={game.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            {/* Overlay */}
            <div
              className="absolute inset-0 flex flex-col items-center justify-center gap-3 opacity-0 group-hover:opacity-100 transition-all duration-300"
              style={{ background: "rgba(8,30,102,0.85)", backdropFilter: "blur(4px)" }}
            >
              <p className="text-white text-xs font-semibold text-center px-2">{game.name}</p>
              <span
                className="w-11 h-11 flex items-center justify-center rounded-full cursor-pointer transition-all duration-200 hover:scale-110"
                style={{
                  background: "linear-gradient(135deg, #105CE8, #0a4bc0)",
                  boxShadow: "0 0 20px rgba(16,92,232,0.6)",
                }}
              >
                <i className="ri-play-fill text-white text-lg"></i>
              </span>
              <span className="text-xs font-bold tracking-widest" style={{ color: '#105CE8' }}>PLAY FOR FUN</span>
            </div>
            {/* Name bar */}
            <div
              className="p-2"
              style={{ background: "rgba(8,30,102,0.8)", borderTop: "1px solid rgba(167,139,250,0.1)" }}
            >
              <p className="text-slate-300 text-xs font-medium truncate">{game.name}</p>
            </div>
          </RegisterLink>
        ))}
      </div>

      {/* Fishing Games */}
      <h3
        className="text-base font-bold mb-4 tracking-widest uppercase"
        style={{ color: "#105CE8", fontFamily: "'Cinzel', serif" }}
      >
        Fishing Games
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {fishingGames.map((g, i) => (
          <div key={i} className="glass-card rounded-xl p-5">
            <h4 className="text-white font-semibold mb-2 text-sm">{g.title}</h4>
            <p className="text-slate-400 text-xs leading-relaxed">{g.body}</p>
          </div>
        ))}
      </div>

      {/* Table Games */}
      <h3
        className="text-base font-bold mb-4 tracking-widest uppercase"
        style={{ color: "#105CE8", fontFamily: "'Cinzel', serif" }}
      >
        Table Games
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {tableGames.map((g, i) => (
          <div key={i} className="glass-card rounded-xl p-5">
            <h4 className="text-white font-semibold mb-2 text-sm">{g.title}</h4>
            <p className="text-slate-400 text-xs leading-relaxed">{g.body}</p>
          </div>
        ))}
      </div>

      {/* Live Dealer Games */}
      <h3
        className="text-base font-bold mb-4 tracking-widest uppercase"
        style={{ color: "#105CE8", fontFamily: "'Cinzel', serif" }}
      >
        Live Dealer Games
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {liveGames.map((g, i) => (
          <div key={i} className="glass-card rounded-xl p-5">
            <h4 className="text-white font-semibold mb-2 text-sm">{g.title}</h4>
            <p className="text-slate-400 text-xs leading-relaxed">{g.body}</p>
          </div>
        ))}
      </div>

      {/* High RTP Slots */}
      <h3
        className="text-base font-bold mb-4 tracking-widest uppercase"
        style={{ color: "#105CE8", fontFamily: "'Cinzel', serif" }}
      >
        High RTP Slots
      </h3>
      <div className="glass-card rounded-xl p-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {[
            { name: "ACE333", rtp: "96.5%" },
            { name: "JILI", rtp: "96.51%" },
            { name: "WF Gaming", rtp: "97.81%" },
            { name: "Booongo", rtp: "97.50%" },
            { name: "918Kiss", rtp: "97.72%" },
            { name: "VPower", rtp: "98.51%" },
            { name: "Live22", rtp: "98.71%" },
            { name: "Pegasus", rtp: "97.50%" },
          ].map((slot, i) => (
            <div key={i} className="flex items-center justify-between px-3 py-2 rounded-lg" style={{ background: "rgba(16,92,232,0.08)", border: "1px solid rgba(16,92,232,0.15)" }}>
              <span className="text-slate-300 text-xs font-medium">{slot.name}</span>
              <span className="text-xs font-bold" style={{ color: "#105CE8" }}>RTP {slot.rtp}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
